export class CodeRequest {
  codeEntity: string;
  codeValue: string;
  entityId: string;
  username: string;
  searchText: string;
  grgrCk: number;
}
